export enum deviceConstants {
  GET_DEVICES = 'GET_DEVICES',
  GET_DEVICE = 'GET_DEVICE',
  ADD_DEVICE = 'ADD_DEVICE',
  EDIT_DEVICE = 'EDIT_DEVICE',
  DELETE_DEVICE = 'DELETE_DEVICE',
  ASSIGN_VEHICLE_TO_DEVICE = 'ASSIGN_VEHICLE_TO_DEVICE',
  IMPORT_DEVICES = 'IMPORT_DEVICES',
}
